import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import CloseBtn from 'assets/icons/Close.svg';
import AuthService from 'services/auth.service';
import queryString from 'query-string';

export function ForgotPasswordModal() {
  const [show, setShow]                     = useState(false);
  const handleClose                         = () => setShow(false);
  const handleShow                          = () => setShow(true);
  const [forgetEmail, setForgetEmail]       = useState('');
  const [validEmail, setValidEmail]         = useState(false);
  const [successMsg, setSuccessMsg]         = useState('');
  const [errorMsg, setErrorMsg]             = useState('');
  const [disabledSubmit, setDisabledSubmit] = useState(false);

  useEffect(() => {
    const checkValidity = forgetEmail.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/); // eslint-disable-line no-control-regex

    setValidEmail(!!checkValidity);
  }, [forgetEmail]);

  // (?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])
  const submitForgetPassword = () => {
    const parameters = queryString.stringify({
      email: forgetEmail
    });

    setSuccessMsg('');
    setErrorMsg('');
    setDisabledSubmit(true);

    AuthService.forgotPassword(parameters).then(
      (data) => {
        setSuccessMsg(data.messages.join(', '));

        setTimeout(function() {
          setDisabledSubmit(false);
        }, 5000);
      },
      (error) => {
        setErrorMsg(error.response.data.errors.join(', '));
      }
    );
  }

  return (
    <div>
      <a className="text-danger d-block mb-8 clickable font-size-7" href="#forgot-password" onClick={ handleShow }>Forgot Password?</a>

      <Modal show={ show } onHide={ handleClose } keyboard={ false } size="lg" centered>
        <Modal.Header className="d-block">
          <h2 className="text-center">Forgot Password</h2>

          <button type="button" className="close" onClick={ handleClose }>
            <img src={ CloseBtn } alt="modal-close" />
          </button>
        </Modal.Header>

        <Modal.Body className="d-block text-center font-size-7">
          <p className="text-center text-grey mb-10">Enter your email below and we will send you a link to reset your password.</p>

          <div className="mb-14">
            <div className="d-flex justify-content-center">
              <input id="forget-password-field" name="email" type="text" placeholder=" " onChange={(e) => setForgetEmail(e.target.value) } className="form-control rounded-pill w-em-50 mb-6"/>
            </div>

            <p className="text-success mb-0">{ successMsg }</p>
            <p className="text-danger mb-0">{ errorMsg }</p>
          </div>

          <button id="sign-in-btn" className="btn btn-danger text-white rounded-pill py-4 px-20" onClick={() => submitForgetPassword() } disabled={ !validEmail || disabledSubmit }>
            Submit
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
}